import ErrorPage404 from "../components/404";
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import nextI18NextConfig from '../next-i18next.config';

export default function Custom404() {
  return <ErrorPage404/>
}

export async function getStaticProps(ctx: any) {
  const translations = await serverSideTranslations(
    ctx?.locale ?? "en",
    ["common", "header", "footer"],
    nextI18NextConfig,
  );
  return {
    props: {
      ...translations,
    },
  }
}

